import React from 'react';
import { pureRender } from 'epic-alt-utils';
import autobind from 'core-decorators/lib/autobind';
import { NavActions } from '../../actions';
import { getDataAttribute } from '../../utils/compatibilityUtils';
import map from 'lodash/map';
import { UserIcon } from '../';
import './signedIn.sass';
import './signedIn-mobile.sass';

@pureRender
export default class SignedIn extends React.Component {

    @autobind
    onSignOutClick(e) {
        if (this.props.signOutLink && this.props.signOutLink.onClick && typeof this.props.signOutLink.onClick === 'function') {
            this.props.signOutLink.onClick(e);
        }

        NavActions.closeMobileTablet.defer();
    }

    @autobind
    onDropdownClick(e) {
        const index = +getDataAttribute(e.currentTarget, 'index');
        const link = this.props.dropdownLinks[index];

        if (link && link.onClick && typeof link.onClick === 'function') {
            link.onClick(e);
        }

        NavActions.closeMobileTablet.defer();
    }

    @autobind
    close() {
        NavActions.mobileUserActive(false);
        NavActions.mobileNavActiveLinks(true);
    }

    render() {
        const messages = this.context.messages || {};
        const username = this.props.displayName || messages.default_username;
        const dropdownLinks = this.props.dropdownLinks || [];
        const signOutLink = this.props.signOutLink || {};

        return (
            <div
                id="user"
                className={`signed-in loggedIn ${this.context.isMobile ? 'rightnav-bg-color' : 'bg-color dropdown'} ${this.props.isActive ? 'active' : ''}`}>
                {!this.context.isMobile ?
                    <UserIcon
                        mobileUserActive={this.props.isActive}
                        isLoggedIn={true}
                        username={username} /> : ''}

                <ul className={`${this.context.isMobile ? 'mobile-list' : 'bg-color'} ${this.props.hideCallToAction ? 'ul-right' : 'ul-left'}`}>
                    {this.context.isMobile ? <li
                        className={`${this.context.isMobile ? 'mobile-heading' : ''}`}
                        onClick={this.close}>
                        <a className={`${!this.context.isMobile ? 'username' : ''}`}>
                            <span className="sign-text item-label text-color">{username}</span>
                        </a>
                    </li> : ''}
                    {
                        map(dropdownLinks, (link, i) => {
                            if (link && link.title) {
                                const key = link.key ? `dropdown-link-${link.key}` : `dropdown-link-${link.title}`;
                                return (
                                    <li className={`${this.context.isMobile ? 'mobile-list-item' : ''}`} key={key}>
                                        <a
                                            className="text-color-hover text-color-nonactive"
                                            href={link.href || '#'}
                                            id={key}
                                            data-index={i}
                                            onClick={this.onDropdownClick}><span>{link.title}</span></a>
                                    </li>
                                );
                            }
                            return undefined;
                        })
                    }
                    <li className="mobile-list-item">
                        <a
                            className="text-color-hover text-color-nonactive"
                            href={signOutLink.href || '#'}
                            id="log-out"
                            onClick={this.onSignOutClick}>
                            <span>{messages.sign_out}</span>
                        </a>
                    </li>
                </ul>
            </div>
        );
    }
}

SignedIn.propTypes = {
    displayName: React.PropTypes.string,
    isActive: React.PropTypes.bool,
    signOutLink: React.PropTypes.object,
    dropdownLinks: React.PropTypes.array,
    hideCallToAction: React.PropTypes.bool
};

SignedIn.contextTypes = {
    isMobile: React.PropTypes.bool,
    messages: React.PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/signedIn/SignedIn.js
 **/